import { Moon, Sun, Laptop } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { useTheme } from "@/providers";

export function ThemeToggle() {
    const { setTheme, theme } = useTheme();

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="outline" size="icon" aria-label="Toggle theme">
                    <Sun className="size-4 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
                    <Moon className="absolute size-4 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
                    <span className="sr-only">Toggle theme</span>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-36">
                <DropdownMenuItem className="hover:cursor-pointer" onClick={() => setTheme('light')} aria-checked={theme === 'light'} data-state={theme === 'light' ? 'checked' : undefined}>
                    <Sun className="mr-2 size-4" /> Light
                </DropdownMenuItem>
                <DropdownMenuItem className="hover:cursor-pointer" onClick={() => setTheme('dark')} aria-checked={theme === 'dark'} data-state={theme === 'dark' ? 'checked' : undefined}>
                    <Moon className="mr-2 size-4" /> Dark
                </DropdownMenuItem>
                <DropdownMenuItem className="hover:cursor-pointer" onClick={() => setTheme('system')} aria-checked={theme === 'system'} data-state={theme === 'system' ? 'checked' : undefined}>
                    <Laptop className="mr-2 size-4" /> System
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
